module.exports = __webpack_public_path__ + "static/media/standing-light-black.5fb9e4b5.svg";